/**
 * @(#)2020/02/27.
 * 展示型icon组件
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import { ITextBasePropTypes } from "../IpropType/basePropTypes";
import Icon from "./Icon";
import PropTypes from "prop-types";

Icon.propTypes = {
  ...ITextBasePropTypes,
  iconfont: PropTypes.bool,
  type: PropTypes.string,
};
Icon.defaultProps = {
  children: "",
  type: "", // icon的值
  iconfont: false,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Icon/index.js